import React, { Component } from "react";
import styles from "./AnnexeCategories.local.scss";
import _ from "i18n";
import classnames from "classnames";
import Select from "react-select";

class LabelsForm extends Component {
  renderFormForCreatedCategory = () => {
    const { labels, indicators } = this.props;

    return (
      <div
        className={styles.labels_form}
        onClick={event => {
          event.stopPropagation();
        }}
      >
        <table>
          <tr>
            <td width={"13%"}>
              <img src={"/img/icons/fr_flag.png"} alt={""} width={22} />
            </td>
            <td>
              <input
                type={"text"}
                placeholder={_("frTitle")}
                value={labels.fr}
                onChange={e => this.props.onChangeLabelFormFr(e)}
                required={true}
              />
              <img src={"/img/icons/pencil.svg"} alt={""} />
            </td>
          </tr>
          <tr>
            <td>
              <img src={"/img/icons/en_flag.png"} alt={""} width={22} />
            </td>
            <td>
              <input
                type={"text"}
                placeholder={_("enTitle")}
                value={labels.en}
                onChange={e => this.props.onChangeLabelFormEn(e)}
                required={true}
              />
              <img src={"/img/icons/pencil.svg"} alt={""} />
            </td>
          </tr>
          <tr>
            <td>
              <img src={"/img/icons/nl_flag.png"} alt={""} width={22} />
            </td>
            <td>
              <input
                type={"text"}
                placeholder={_("nlTitle")}
                value={labels.nl}
                onChange={e => this.props.onChangeLabelFormNl(e)}
                required={true}
              />
              <img src={"/img/icons/pencil.svg"} alt={""} />
            </td>
          </tr>
          <tr className={styles.associatedAccountBlock}>
            <td>
              <span className={styles.label_span}>Associée à</span>
            </td>
            <td style={{ textAlign: "left" }}>
              <Select
                value={
                  this.props.selectedAccount &&
                  indicators.find(
                    obj => obj.value === this.props.selectedAccount
                  )
                }
                onChange={this.props.onChangeSelectedAccount}
                options={indicators}
                className={classnames("indicators", "created")}
                classNamePrefix="ttp-select"
                isClearable={true}
                placeholder={"Comptes et indicateurs..."}
                menuPlacement="auto"
              />
            </td>
          </tr>
        </table>
      </div>
    );
  };

  renderFormForStandardCategory = () => {
    const { indicators } = this.props;

    return (
      <div
        className={classnames(styles.labels_form, styles.standard)}
        onClick={event => {
          event.stopPropagation();
        }}
      >
        <table>
          <tr>
            <td width={"13%"}>
              <span className={styles.label_span}>Associée à</span>
            </td>
            <td style={{ textAlign: "left" }}>
              <Select
                value={
                  this.props.selectedAccount &&
                  indicators.find(
                    obj => obj.value === this.props.selectedAccount
                  )
                }
                onChange={this.props.onChangeSelectedAccount}
                options={indicators}
                className={"indicators"}
                classNamePrefix="ttp-select"
                isClearable={true}
                placeholder={"Comptes et indicateurs..."}
                menuPlacement="auto"
              />
            </td>
          </tr>
        </table>
      </div>
    );
  };

  render() {
    const { type } = this.props;

    if (type === "CREATED") {
      return this.renderFormForCreatedCategory();
    }
    if (type === "STANDARD") {
      return this.renderFormForStandardCategory();
    }
  }
}

export default LabelsForm;



// WEBPACK FOOTER //
// ./src/components/AnnexeCategories/LabelsForm.js